<template>
  <button
    :disabled="submitting || disabled"
    :type="type"
    class="btn -material"
    :class="[{ submitting: submitting }, classes]"
    :aria-label="submitting ? submittingLabel : label"
    @click.prevent="handleClick"
  >
    <i v-show="showIcon" :class="materialFontClasses" aria-hidden="true">{{ icon }}</i>
    <span v-if="submitting" class="btn-txt" :class="{ '-reduce': reduce }">{{
      submittingLabel
    }}</span>
    <span v-else class="btn-txt" :class="{ '-reduce': reduce }">{{ label }}</span>
  </button>
</template>

<script>
// @flow
export default {
  name: 'MaterialIconButton',
  components: {},
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
    },
    submittingLabel: {
      type: String,
      default: 'Saving...',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: '',
    },
    reduce: {
      type: Boolean,
      default: true,
    },
    rotateIcon: {
      type: Number,
      default: 0,
    },
    classes: {
      type: String,
      default: '',
    },

    // default to outlined font, see materialFontClasses for computed toggle
    iconsOutlined: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    materialFontClasses() {
      const fontLib = this.iconsOutlined ? 'material-icons-outlined' : 'material-icons'

      // font rotation
      let rotateClass = ''

      if (this.rotateIcon && this.rotateIcon === 90) {
        rotateClass = `-rotate-${this.rotateIcon}`
      }
      // end font rotation

      return `${fontLib} md-light btn-ico ${rotateClass}`
    },
  },

  // instance methods
  methods: {
    handleClick(event: MouseEvent) {
      this.$emit('click-action', event)
    },
  },
}
</script>
